function view (path) {
  return () => import(/* webpackChunkName: 'security' */ '@/views/security/' + path + '.vue').then(m => m.default || m) // eslint-disable-line prefer-template
}

const RSecurity = [
  {
    path: '/security/dashboard',
    component: view('Dashboard'),
    name: 'security.dashboard',
    meta: {
      middleware: ['auth', 'security-personel'],
      breadcrumb: [
        {
          text: 'Security'
        },
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  },
  {
    path: '/security/violations',
    component: view('Violations'),
    name: 'security.violations',
    meta: {
      middleware: ['auth', 'security-personel'],
      breadcrumb: [
        {
          text: 'Security'
        },
        {
          text: 'Violation Reports',
          active: true
        }
      ]
    }
  },
  {
    path: '/security/violations/report',
    component: view('ViolationReport'),
    name: 'security.violation-report',
    meta: {
      middleware: ['auth', 'security-personel'],
      breadcrumb: [
        {
          text: 'Security'
        },
        {
          text: 'Violations'
        },
        {
          text: 'New Report',
          active: true
        }
      ]
    }
  }
]

export default RSecurity
